import type { AutoCompleteDesignTokens, AutoCompleteTokenSections } from '@openng/optimus-ui-themes/types/autocomplete';

export const root: AutoCompleteTokenSections.Root = {
	placeholderColor: '{surface.200}',
};

export default {
	root,
} satisfies AutoCompleteDesignTokens;
